import messages from "messages";
// constants
import { IMPORT_SOURCES } from "../../constants";
// components
import DataTransferSource from "./components/data-transfer-source";
// styles
import styles from "./styles.module.scss";

/**
 * renders UI for import sources in data transfer page
 */
const Sources = () => {
  return (
    <article className={styles["sources"]}>
      <h2 className={styles["sources__title"]}>{messages.importFrom}</h2>
      <div className={styles["sources__list"]}>
        {Object.values(IMPORT_SOURCES).map((el) => (
          <DataTransferSource key={el.id} value={el} />
        ))}
      </div>
    </article>
  );
};

export default Sources;
